import React from 'react';
import AccountingLedgerFilters, { AccountingLedgerFiltersProps } from './AccountingLedgerFilters';

type AccountingFiltersProps = Omit<AccountingLedgerFiltersProps, 'view'>;

const AccountingFilters: React.FC<AccountingFiltersProps> = (props) => (
    <AccountingLedgerFilters {...props} view="accounting" />
);

export default AccountingFilters;
